import styled from "styled-components";

export const NpcItemHeader = styled.div`
  display: flex;
  justify-content: space-between;

  input {
    width: 33%;
  }

  .col-new-npc-item__wrapper {
    min-width: 220px;
  }

  .btn[data-testid^="npc-item__suggest-new"] {
    max-width: calc(100% - 24px);
  }
`;